import { signalStore } from '@ngrx/signals';
import { withChangePassword } from './withChangePassword';
import { withRequestEmailChange } from './withRequestEmailChange';
import { withUserProfile } from './withUserProfile';

export const UserProfileStore = signalStore({ providedIn: 'root' }, withUserProfile(), withRequestEmailChange(), withChangePassword());
